export const roundTime = (number: number) => {
  return number > 9 ? number : `0${number}`;
};
